import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppBreadcrumb } from './useAppBreadcrumb';

export const useGetRouteProps = <T extends string>(): Record<T, unknown> | undefined => {
  const location = useLocation();
  const { breadcrumb } = useAppBreadcrumb();

  return useMemo(
    () => breadcrumb.find((el) => el.key === location.pathname)?.match.route?.props as Record<T, unknown> | undefined,
    [breadcrumb, location.pathname]
  );
};
